module.exports = __webpack_public_path__ + "static/media/new-wordmark-vector.9797f8f2.svg";